export default '<svg viewBox="0 0 24 24">\
    <g fill="var(--color)">\
        <circle cx="2" cy="12" r="2"/>\
        <circle cx="10" cy="12" r="2"/>\
        <circle cx="18" cy="12" r="2"/>\
    </g>\
</svg>'
